<template>
  <b-dropdown
    split
    ref="selectDropdown"
    :class="`select-dropdown ${getCustomClass}`"
    :variant="isDarkMode ? 'dark' : 'light'"
    :disabled="disabled"
  >
    <template #button-content>
      <span
        v-if="currentSelectedItem"
        class="select-dropdown--selected d-inline-flex w-100 h-100 align-items-center"
        style="padding: .375rem .75rem;"
        @click="showDropdown"
      >
        {{ currentSelectedItem.label }}
      </span>
      <span
        v-else
        class="select-dropdown--selected d-inline-flex w-100 h-100 align-items-center"
        style="padding: .375rem .75rem;"
        @click="showDropdown"
      >
        {{ placeholder }}
      </span>
    </template>
    <b-dropdown-header v-if="showSearch" class="select-dropdown--search">
      <b-form-input v-model="search" placeholder="Search items..."></b-form-input>
    </b-dropdown-header>
    <b-dropdown-item
      v-for="dropdownItem in filteredDropdownItems"
      class="select-dropdown--item"
      :key="dropdownItem.value"
      @click="selectOption($event, dropdownItem)"
    >
      <div
        class="select-dropdown--item-check mr-2"
        :style="{
          opacity: dropdownItem.value === currentValue ? 1 : 0
        }"
      >
        <b-icon icon="check2"></b-icon>
      </div>
      <div class="select-dropdown--item-label">{{ dropdownItem.label }}</div>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
export default {
  name: "SelectDropdown",
  props: {
    customClass: {
      type: [String, Array],
      default: () => [],
    },
    value: {
      type: String,
      default: "",
    },
    options: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "",
    },
    showSearch: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      dropdownItems: [],
      filteredDropdownItems: [],
      currentValue: "",
      search: "",
    };
  },
  computed: {
    ...mapGetters("user", ["isDarkMode"]),
    getCustomClass() {
      if (Array.isArray(this.customClass) && this.customClass.length > 0) {
        return this.customClass.join(" ");
      } else if (typeof this.customClass === "string") {
        return this.customClass;
      } else {
        return "";
      }
    },
    currentSelectedItem() {
      return this.dropdownItems.find(item => item.value === this.currentValue);
    }
  },
  methods: {
    initDropdown(initValue) {
      this.currentValue = initValue;
      this.dropdownItems = [...this.options];
      this.getFilteredItems(this.search);
    },
    emitChanges() {
      this.$emit('input', this.currentValue);
      this.$emit('selected', this.currentValue);
    },
    selectOption($event, option) {
      $event.stopPropagation();
      const { value } = option;
      this.currentValue = value;
      this.getFilteredItems(this.search);
      this.emitChanges();
    },
    getFilteredItems(searchQuery) {
      if (!searchQuery || searchQuery === "") {
        this.filteredDropdownItems = [...this.dropdownItems];
      } else {
        searchQuery = searchQuery.toLowerCase();
        this.filteredDropdownItems = this.dropdownItems.filter(item => {
          const { label } = item;
          const lowerCasedLabel = label.toLowerCase();
          return lowerCasedLabel.includes(searchQuery);
        });
      }
    },
    showDropdown() {
      this.$refs.selectDropdown.show();
    }
  },
  watch: {
    search(value) {
      this.getFilteredItems(value);
    },
    value: {
      handler(value) {
        this.initDropdown(value);
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="scss">
.select-dropdown {
  width: 100%;
  min-width: 120px;
  &.btn-group {
    >button {
      text-align: left;
      &:first-child {
        padding: 0;
      }
    }
    .dropdown-toggle-split {
      flex: unset;
    }
  }
  &--selected {

  }
  &--item {
    .dropdown-item {
      display: flex;
      align-items: center;
    }
  }
  ul.dropdown-menu {
    max-height: 300px;
    overflow-y: auto;
  }
}
</style>